import { EmailAuthProvider, browserLocalPersistence, browserSessionPersistence, fetchSignInMethodsForEmail, getAuth, onAuthStateChanged, sendPasswordResetEmail, setPersistence, signInWithEmailAndPassword } from 'firebase/auth';
import { addListnerForAuthStateVisibility, initFirebase } from "./utils/fbase";
import { toast } from "bulma-toast"
import { redirectAfterSignin } from './utils/helper-functions';

initFirebase()

onAuthStateChanged(getAuth(), (user) => {
    if (user) redirectAfterSignin()
})

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded")
    console.log(process.env.FBASE_APP_ID)

    addListnerForAuthStateVisibility()

    const form_signin = document.getElementById('form_signin')

    form_signin.addEventListener('submit', async (ev) => {
        ev.preventDefault()
        const form = ev.target

        const email = form.email.value
        const auth = getAuth()
        form.submit.classList.add('is-loading')

        const providers = await fetchSignInMethodsForEmail(auth, email)

        if (providers.includes(EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)) {

            sendPasswordResetEmail(auth, email, {
                url: location.origin
            })
                .then(() => {
                    alert(`A email with the password reset link has been sent to ${email}. Just, click on the link to reset your password.`)
                    form.submit.classList.remove('is-loading')
                })
                .catch(error => {
                    toast({
                        type: 'is-danger',
                        dismissible: true,
                        position: 'top-center',
                        message: 'Some error occurred! Please, try again after some time or contact us.'
                    })
                    form.submit.classList.remove('is-loading')
                    console.error("Firebase: Could not send password reset link.", error)
                })
        }
        else {
            alert(`User with email ${email} does not exist.`)
            form.submit.classList.remove('is-loading')
            form.reset()
        }
    })


    try {
        const btn_signout_el = document.getElementById('btn_signout')
        btn_signout_el.addEventListener('click', () => {
            btn_signout_el.classList.add('is-loading')
            handleSignOut()
            btn_signout_el.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_signout.", error)
    }

})